module.exports = __webpack_public_path__ + "img/illustration-invite-friends.8a6dee80.svg";